<template lang="pug">
div
  UiStack(vertical)
    RestTable(
      namespace="customers"
      :headers="headers"
      ref="table"
      :fetch-handler="getData"
      :initial-filters="initialFilters"
      embed
    )
      template(#filters="{ filters, updateFilters }")
        UiStack
          UiStackItem
            UiStack
              UiStackItem
                label(label-for="status") {{ $t("labels.status") }}
              UiStackItem
                UiSelect.filter-input(
                  :searchable="false"
                  :options="statusOptions"
                  :modelValue="filters.status"
                  @update:modelValue="updateFilters({ status: $event || undefined })"
                )
          UiStackItem
            UiStack
              UiStackItem
                label(label-for="status") {{ $t("labels.files") }}
              UiStackItem
                DigiaFileSelect.filter-input(
                  multiselect
                  :companyId="globalRequestFilters.company_id"
                  :dateStart="globalRequestFilters.date_start"
                  :dateEnd="globalRequestFilters.date_end"
                  @update:modelValue="updateFilters({ file_ids: $event })"
                  :modelValue="filters.file_ids"
                )
          UiStackItem(fill)
          UiStackItem
            UiButton(
              variant="primary"
              @click="callRestartDialog"
              icon="RefreshCw"
            ) {{ $t("actions.restart_all_failed") }}
      template(v-slot:cel_customer_number="{ item }")
        a(
          href="#"
          @click="showCustomerInfo($event, item)"
        ) {{ item.customer_number }}
      template(v-slot:cel_status="{ item }")
        CustomerStatusBadge(:status="item.status")
      template(v-slot:cel_filename="{ item }")
        RouterLink(:to="getFileFilterLink(item)") {{ item.filename }}
  ShowCustomerInfoModal(ref="showCustomerInfoModal")
</template>

<script>
import ApiDigiaCustomers from "@/api/digia_customers.js";
import CustomerStatusBadge from "./components/customer_status_badge.vue";
import DigiaFileSelect from "@/components/DigiaFileSelect.vue";
import ShowCustomerInfoModal from "@/modals/Digia/showCustomerInfo.vue";
import isEqual from "lodash/isEqual";

export default {
  components: {
    CustomerStatusBadge,
    DigiaFileSelect,
    ShowCustomerInfoModal,
  },
  props: {
    globalRequestFilters: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      initialFilters: {
        status: null,
        files: [],
      },
    };
  },

  computed: {
    headers() {
      return [
        {
          key: "customer_number",
          label: this.$t("labels.customer_number"),
          sortable: true,
        },
        {
          key: "filename",
          label: this.$t("labels.file_name"),
          sortable: true,
        },
        {
          key: "created_at",
          label: this.$t("labels.date"),
          sortable: true,
        },
        {
          key: "status",
          label: this.$t("labels.status"),
          sortable: true,
        },
        {
          key: "status_reason",
          label: this.$t("labels.status_reason"),
          width: "35%",
        },
      ];
    },

    statusOptions() {
      return [
        {
          value: null,
          label: this.$t("labels.any_status"),
        },
        {
          value: "failed",
          label: this.$t("labels.failed"),
        },
        {
          value: "processed",
          label: this.$t("labels.processed"),
        },
        {
          value: "processing",
          label: this.$t("labels.processing"),
        },
      ];
    },
  },

  watch: {
    globalRequestFilters: {
      handler(newValue, oldValue) {
        if (isEqual(newValue, oldValue)) return;
        this.refetchTable();
      },
      deep: true,
    },
  },

  methods: {
    refetchTable() {
      this.$refs.table.fetchData();
    },

    getData(params, config) {
      return ApiDigiaCustomers.fetchAll(
        {
          ...params,
          ...this.globalRequestFilters,
        },
        config,
      ).then((response) => {
        return {
          items: response.data.customers,
          meta: response.data.meta,
        };
      });
    },

    callRestartDialog() {
      this.$dialogConfirm({
        title: "Restart all failed",
        description: "Do you really want to restart all failed?",
        variant: "danger",
        okLabel: this.$t("actions.restart_all_failed"),
      }).then((result) => {
        if (!result) return;
        ApiDigiaCustomers.restart({
          ...this.globalRequestFilters,
        }).then(() => {
          this.refetchTable();
        });
      });
    },

    getFileFilterLink(item) {
      return {
        ...this.$route,
        query: {
          ...this.$route.query,
          files: JSON.stringify([
            { value: item.file_id, label: item.filename },
          ]),
        },
      };
    },

    showCustomerInfo(event, customer) {
      this.$refs.showCustomerInfoModal.open({ customer });
    },
  },
};
</script>
